import { useLocation, useNavigate } from "react-router-dom";
import CustomDataGrid from "../../components/dms_common/CustomDataGrid";
import GenericFormHeader from "../../components/dms_common/GenericFormHeader";
import "./salesReturnSkuSelection.css"
import { useCallback, useEffect, useState } from "react";
import { DetailsBoxDivision, Invoice, ReturnSkuDetail, SalesDetail, TaxDetails } from "../../types/types";
import { getDataFromLocalDb } from "../../services/dbService";
import { openPopup } from "../../stateManagement/actions/popupActions";
import { getBatchDetailsFromDb, getProductDetailsFromDb, applyBatchIdSplitting, getReturnWithoutInvoiceReqBody, validateReturnDetails } from "../SalesReturn/SalesReturnService";
import Header from "../../components/dms_common/Header";
import DetailsBox from "../../components/dms_common/DetailsBox";
import dayjs from "dayjs";
import { logLoadTrace } from "../../firebase";
import { getUomLabel } from "../../components/dms_common/DmsUtils";
import { getPieceFilterMapping } from "../createSecondaryOrder/CreateSecondaryOrderService";


const SalesReturnSkuSelection = () => {

    const navigate = useNavigate();
    const location = useLocation();
    const [filteredDetails, setFilteredDetails] = useState<ReturnSkuDetail[]>([]);
    const [returnDetails, setReturnDetails] = useState<ReturnSkuDetail[]>([]);
    const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
    const [detailsBoxDivisions, setDetailsBoxDivisions] = useState<DetailsBoxDivision[]>([]);
    const outletDetails: any = location.state.outletDetails;
    const allowBatchId:boolean = location.state.allowBatchId;

    if (!outletDetails) {
        navigate(-1);
    }

    const { caseUnitLabel, otherUnitLabel, packUnitLabel } = getUomLabel();



    const fetchAndUpdateSalesDetails = async () => {
        const batchDetails = await getBatchDetailsFromDb();
        const productData = await getProductDetailsFromDb();
        const allReturnDetails = batchDetails ? Object.keys(batchDetails).map(batchCode => {
            return {
                id: batchCode,
                skuCode: productData[batchCode].skuCode,
                batchCode: batchCode,
                skuName: productData[batchCode].skuDescription,
                batchIds: batchDetails[batchCode],
                ptr: productData[batchCode].price,
                batchIdCount: Object.keys(batchDetails[batchCode]).length,
                packType: getPieceFilterMapping(productData[batchCode].pieceSize),
                caseQuantity: Object.values(batchDetails[batchCode]).reduce((acc, current) => acc + current.reduce((acc, current) => acc + current.caseQty, 0),0),
                otherUnitQuantity: Object.values(batchDetails[batchCode]).reduce((acc, current) => acc + current.reduce((acc, current) => acc + current.otherQty, 0),0),
                otherUnitName:productData[batchCode].otherUnitName,
                pieceQuantity: Object.values(batchDetails[batchCode]).reduce((acc, current) => acc + current.reduce((acc, current) => acc + current.pieceQty, 0),0)
            } as ReturnSkuDetail;
        }) : [];
        setFilteredDetails(allReturnDetails);
        setReturnDetails(allReturnDetails);
        setDetailsBox();

    }

    useEffect(() => {
        logLoadTrace(fetchAndUpdateSalesDetails, "create_sale_returns_page_load_time");
    }, [])

    const getUnsaleableData = (reqBody:any) => {
        return reqBody.salesDetails.filter((detail:any)=>detail.saleCondition == "Unsaleable");
    }
    const handleCreateSalesReturn = async () => {
        const ConfigDictionary = JSON.parse(localStorage.getItem("ConfigDictionary") || "{}");
        const batchIdConfiguration: boolean= ConfigDictionary?.batchIdConfiguration;
        setIsSubmitting(true);
        try{
                const reqBody = await getReturnWithoutInvoiceReqBody(outletDetails.outletCode, returnDetails, outletDetails.salesRepId);
                // const unsaleableData = getUnsaleableData(reqBody);
                const invoiceDetails = await validateReturnDetails(outletDetails.outletCode, returnDetails, outletDetails.salesRepId, outletDetails.salesRepName, batchIdConfiguration); 
                // const updatedInvoiceDetails= applyBatchIdSplitting(batchIdConfiguration, invoiceDetails);
                
                navigate("review",{
                    state:{
                        invoiceDetails,
                        isReturnInvoice:true,
                        reqBody,
                        // unsaleableData,
                        submission:"createReturn"
                    }
                })
            }catch(e){
                openPopup("Error","Validation failed, please try again")
            }
        setIsSubmitting(false);
    }



    const handleRedirect = async (redirectUrl: string, rowData: SalesDetail) => {
        navigate(redirectUrl, {
            state: {
                rowData: rowData,
                allowBatchId,
            }
        });
    };

    const handleAddMore = async () => {
        navigate("add",{
            state: {
                allowBatchId,
            }
        });
    }

    const handleSearch = useCallback((searchStr: string) => {
        if(searchStr){
            const updatedFilteredDetails = returnDetails.filter(detail => detail.skuName.toLowerCase().includes(searchStr.toLowerCase())
            || detail.batchCode.toLowerCase().includes(searchStr.toLowerCase())
            || detail.packType.toLowerCase().includes(searchStr.toLowerCase())
        );
            setFilteredDetails(updatedFilteredDetails)
        }else{
            setFilteredDetails(returnDetails)
        }
    }, [])

    const setDetailsBox = async () => {
        const divisions: DetailsBoxDivision[] = [
            {
                components: [
                    {
                        label: "Outlet Code",
                        value: outletDetails.outletCode
                    }
                ]
            },
            {
                components: [
                    {
                        label: "Outlet Name",
                        value: outletDetails.outletName
                    }
                ]
            },
            {
                components: [
                    {
                        label: "Return date",
                        value: dayjs().format("DD-MM-YYYY")
                    }
                ]
            }
        ]
        setDetailsBoxDivisions(divisions);
    }

    const headerDetails = [
        {
            label: "Sale Return",
            redirectFunction: () => { navigate(-2) }
        },
        {
            label: "Create New Return",
            redirectFunction: () => { navigate(-1) }
        },
        {
            label: "Add SKUs"
        }
    ]

    const getFooterElement = () => {
        return (
            <div className="sale-return-submit-button-container">
                <button
                    className={`sale-return-submit ${isSubmitting ? "disabled" : ""}`}
                    onClick={handleCreateSalesReturn}
                >
                    <span className="sale-return-submit-text">
                        Review Return
                    </span>
                </button>
            </div>
        )
    }

    useEffect(() => {
  const handleKeyDown = (event: KeyboardEvent) => {
      if ((event.ctrlKey || event.metaKey) && event.key === 'a') {
        event.preventDefault();
        if (!isSubmitting) {
          try {
            handleCreateSalesReturn();
          } catch (e) {
            // Error handled by validateReturnDetails via openPopup
          }
        }
      } else if ((event.ctrlKey || event.metaKey) && event.key === 'k') {
        event.preventDefault();
        handleAddMore();
      }
  };

  window.addEventListener('keydown', handleKeyDown);
  return () => {
    window.removeEventListener('keydown', handleKeyDown);
  };
}, [isSubmitting, handleCreateSalesReturn, handleAddMore]);

    return (
        <div className="sale-return-details-container">

            <GenericFormHeader
                labelDetails={headerDetails}
                searchFunction={handleSearch}
            />
            <DetailsBox divisions={detailsBoxDivisions} />
            <Header
                title={"Add Products to Add Return Qty"}
            />
            <div className="sales-return-summary-container">
                <div className="create-sales-return-summary">
                    <div className="create-sales-return-summary-title">Return Summary</div>
                    <div className="create-sales-return-summary-content">
                        <div className="create-sales-return-summary-qty-tile">
                            <div className="create-sales-return-summary-qty">
                                {caseUnitLabel && <div className="create-sales-return-summary-qty-content">
                                    <div className="create-sales-return-summary-qty-value">{returnDetails.reduce((prev, curr) => prev + curr.caseQuantity, 0)}</div>
                                    <div className="create-sales-return-summary-qty-label">{caseUnitLabel}</div>
                                </div>}
                                {otherUnitLabel && <div className="create-sales-return-summary-qty-content">
                                    <div className="create-sales-return-summary-qty-value">{returnDetails.reduce((prev, curr) => prev + curr.otherUnitQuantity, 0)}</div>
                                    <div className="create-sales-return-summary-qty-label">{otherUnitLabel}</div>
                                </div>}
                                {packUnitLabel && <div className="create-sales-return-summary-qty-content">
                                    <div className="create-sales-return-summary-qty-value">{returnDetails.reduce((prev, curr) => prev + curr.pieceQuantity, 0)}</div>
                                    <div className="create-sales-return-summary-qty-label">{packUnitLabel}</div>
                                </div>}
                            </div>
                            <div className="create-sales-return-summary-qty-title">Total Return Qty</div>
                        </div>
                        {/* <Divider
                            style={{
                                borderRight: "2px dotted",
                                color: "#dfe2e7",
                                boxSizing: "border-box",
                                backgroundColor: "transparent"
                            }}
                            orientation="vertical"
                            flexItem
                        />
                        <div className="create-sales-return-summary-value-tile">
                            <div className="create-sales-return-summary-value">25k</div>
                            <div className="create-sales-return-summary-value-title">Total Return Value</div>
                        </div> */}
                    </div>
                </div>
                <div className="create-sales-add-more-button" onClick={handleAddMore}>+ Add More</div>
            </div>
            <CustomDataGrid
                rows={filteredDetails}
                columnsMetaData={getSalesReturnDetailsColumnMetaData()}
                tableWidth={0.78}
                redirectUrl={"add"}
                redirectUrlFunction={handleRedirect}
                footerElement={getFooterElement}
            />
        </div>
    )
}

const getSalesReturnDetailsColumnMetaData = () => ({
    columns: [
        {
            headerName: "SKU Code",
            mappedValue: "batchCode",
            width: 30,
            headerAlign: "left",
            align: "left",
        },
        {
            headerName: "SKU Name",
            mappedValue: "skuName",
            width: 90,
            headerAlign: "left",
            align: "left",
        },
        {
            headerName: "Pack Type",
            mappedValue: "packType",
            width: 30,
            headerAlign: "left",
            align: "left",
        },
        // {
        //     headerName: "Batch Ids",
        //     mappedValue: "batchIdCount",
        //     width: 15,
        //     headerAlign: "center",
        //     align: "center",
        // },
        {
            headerName: "PTR",
            mappedValue: "ptr",
            width: 30,
            headerAlign: "left",
            align: "left",
            amountDisplay: true
        },
        {
            headerName: "Return Qty",
            mappedValue: "caseQuantity,pieceQuantity,otherUnitQuantity",
            width: 30,
            headerAlign: "left",
            align: "left",
            qtyDisplay: true,
            hasEditPenSvg: true,
            isEditable: true
        }
    ],
    Actions: [],
});

export default SalesReturnSkuSelection;